import Select from "react-select";
import PropTypes from "prop-types";

const matchBasic = (opt, current, strCurrent) =>
  opt.value === current ||
  (typeof opt.value === "string" && String(opt.value).trim() === strCurrent) ||
  Boolean(opt.label && String(opt.label).trim() === strCurrent);

const matchPipeParts = (opt, pipeParts) => {
  if (!pipeParts) return false;
  const [codePart, namePart] = pipeParts;
  return Boolean(
    (opt.value !== undefined && opt.value !== null && String(opt.value).trim() === codePart) ||
    (opt.label && String(opt.label).trim() === namePart) ||
    (codePart && namePart && opt.label && String(opt.label).trim() === `${codePart} - ${namePart}`)
  );
};

const matchOptPipe = (opt, strCurrent) => {
  if (typeof opt.value !== "string" || !opt.value.includes("|")) return false;
  const [optCode, optName] = opt.value.split("|").map(p => p.trim());
  return strCurrent === optCode || strCurrent === optName;
};

const matchObjectByPipe = (v, pipeParts) => {
  if (!pipeParts) return false;
  const [codePart, namePart] = pipeParts;
  return Boolean(
    (v.id && String(v.id).trim() === codePart) ||
    (v.Planhorariocodigoerp && String(v.Planhorariocodigoerp).trim() === codePart) ||
    (v.Planhorarionombre && String(v.Planhorarionombre).trim() === namePart)
  );
};

const matchObjectOptValue = (opt, strCurrent, pipeParts) => {
  if (typeof opt.value !== "object" || opt.value === null) return false;
  const v = opt.value;
  const matchDirect = Boolean(
    (v.NOMBRE_UO && String(v.NOMBRE_UO).trim() === strCurrent) ||
    (v.nombre && String(v.nombre).trim() === strCurrent) ||
    (v.id && String(v.id).trim() === strCurrent)
  );

  return matchDirect || matchObjectByPipe(v, pipeParts);
};

const matchOptionByString = (opt, current, strCurrent, pipeParts) =>
  matchBasic(opt, current, strCurrent) ||
  matchPipeParts(opt, pipeParts) ||
  matchOptPipe(opt, strCurrent) ||
  matchObjectOptValue(opt, strCurrent, pipeParts);

export const InputSelect = props => {
  const {
    arr = [],
    id,
    formik,
    label = "xxx",
    llave_texto = "nombre",
    llave_valor = "id",
    ejecute,
    disabled = false,
    clases = "",
    subKey = "",
    placeholder = "---Seleccione---",
    labelStyle,
    labelClassName,
    menuPlacement = "auto",
  } = props;

  const arrOpts = (t, texto, valor) => (t || []).map(el => ({ label: el[texto], value: valor ? el[valor] : el }));
  const options = arrOpts(arr, llave_texto, llave_valor);

  const getSelectValue = () => {
    const current = formik?.values?.[id];
    if (current === undefined || current === null || current === "") {
      return null;
    }
    if (typeof current === "object" && current !== null) {
      return (
        options.find(opt => {
          if (!opt.value) return false;
          if (opt.value === current) return true;
          if (opt.value.id && current.id && String(opt.value.id) === String(current.id)) return true;
          if (opt.value.NOMBRE_UO && current.NOMBRE_UO && opt.value.NOMBRE_UO === current.NOMBRE_UO) return true;
          return JSON.stringify(opt.value) === JSON.stringify(current);
        }) || null
      );
    }
    const strCurrent = String(current).trim();
    const pipeParts = strCurrent.includes("|") ? strCurrent.split("|").map(p => p.trim()) : null;

    return options.find(opt => matchOptionByString(opt, current, strCurrent, pipeParts)) || null;
  };

  const formatLabel = (txt) => {
    if (typeof txt !== "string") return txt;
    if (txt.includes("*")) {
      const parts = txt.split("*");
      return (
        <>
          {parts[0]} <span className="text-danger fw-bold">*</span>
          {parts.slice(1).join("*")}
        </>
      );
    }
    return txt;
  };

  return (
    <>
      {Boolean(label) && label !== "xxx" && (
        <label
          htmlFor={id}
          className={labelClassName || "form-label fw-bold mb-1"}
          style={labelStyle}
        >
          {formatLabel(label)}
        </label>
      )}
      <Select
        key={subKey}
        isDisabled={disabled}
        texto=""
        name={id}
        id={id}
        className={`selectDos ${clases}`}
        value={formik ? getSelectValue() : undefined}
        onChange={e => {
          formik ? formik.setValues({ ...formik.values, [id]: e ? e.value : "" }) : ejecute(e);
        }}
        placeholder={placeholder}
        isClearable={true}
        menuPlacement={menuPlacement}
        menuPosition="fixed"
        maxMenuHeight={220}
        classNamePrefix={"limpiarSelect"}
        options={options}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          menu: base => ({ ...base, zIndex: 9999 }),
        }}
      />
    </>
  );
};

InputSelect.propTypes = {
  arr: PropTypes.array,
  id: PropTypes.string,
  formik: PropTypes.object,
  label: PropTypes.string,
  llave_texto: PropTypes.string,
  llave_valor: PropTypes.string,
  ejecute: PropTypes.func,
  disabled: PropTypes.bool,
  clases: PropTypes.string,
  subKey: PropTypes.string,
  placeholder: PropTypes.string,
  labelStyle: PropTypes.object,
  labelClassName: PropTypes.string,
  menuPlacement: PropTypes.string,
};
